import React, {FC} from 'react';
import styled from 'styled-components';

import {
  directHoverSelector,
  hoverSelector,
} from '../../../../../libs/shared/core/src/helpers/browser/hoverHelpers';
import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {UserTheme} from '../../../../../libs/shared/ui/src/theme/themeTypes';

/*
 * Props.
 */

interface WorkspaceLineMoreButtonProps {
  theme: UserTheme;
  isMoreOpen: boolean;
}

/*
 * Style.
 */

const StyledMoreButton = styled(ChromelessButton)`
  display: none;
  transform: rotate(90deg);
  border-radius: 4px;
  background-color: ${(p) => p.theme.alphas.transparent};

  ${hoverSelector} {
    display: block;
  }

  ${directHoverSelector} {
    display: block;
    background-color: ${(p) => p.theme.itemMoreIconBackgroundHover};
  }
`;

/*
 * Component.
 */

export const WorkspaceLineMoreButton: FC<WorkspaceLineMoreButtonProps> = ({theme, isMoreOpen}) => (
  <TooltipCoordinator render={() => <Trans id="show-actions-copy">Show actions</Trans>}>
    <StyledMoreButton hasHover={isMoreOpen}>
      <Icon
        name="more"
        color={theme.itemMoreIcon}
        hoverColor={theme.itemMoreIconHover}
        hasHover={isMoreOpen}
      />
    </StyledMoreButton>
  </TooltipCoordinator>
);
